import React from 'react';
import { SETTINGS } from 'modules/emergencies/constants';
import Column from '../../../ui/columns/column';
import Menu from '../../../ui/menus/kebab/Menu';
import MenuItem from '../../../ui/menus/kebab/MenuItem';
import useActions from '../hooks/useActions';
import ActionComponent from '../actions/ActionComponent';
import { Tooltip } from '@ontruck/orc';
import TooltipHeader from 'modules/emergencies/components/ui/texts/TooltipHeader';
import ticketActions from '../../../../constants/ticketActions';
import styled from 'styled-components';
import {
  FranceFlagIcon,
  ManualAssignFlagIcon,
  PolandFlagIcon,
  RomaniaFlagIcon,
  SpainFlagIcon,
} from '@ontruck/fe-icons';

const StyledColumn = styled(Column)`
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const RegionContainerComponent = styled.div`
  background-color: var(--grey200);
  height: 40%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
`;

const RegionTextComponent = styled.div`
  color: var(--grey700);
  font-weight: bold;
  text-transform: uppercase;
`;

const RegionFlagComponent = styled.div`
  background-color: green;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const getWorkingAreaFlag = (workingAreas) => {
  if (workingAreas.length > 1) {
    return <ManualAssignFlagIcon widthInPixels={24} />;
  }
  if (workingAreas.length === 0) {
    return null;
  }
  const currentWorkingArea = workingAreas[0].slug;
  if (currentWorkingArea === 'PL') return <PolandFlagIcon />;
  if (currentWorkingArea === 'SEM') return <SpainFlagIcon />;
  if (currentWorkingArea === 'RO') return <RomaniaFlagIcon />;
  if (currentWorkingArea === 'FR') return <FranceFlagIcon />;
  return null;
};

export const ActionsColumn = ({ ticket }) => {
  const actions = useActions(ticket);
  const workingAreas = ticket?.working_areas || [];
  let currentWorkingArea = '';
  if (workingAreas.length === 1) {
    currentWorkingArea = workingAreas[0].slug;
  }
  const workingAreaFlag = getWorkingAreaFlag(workingAreas);

  return (
    <StyledColumn width={SETTINGS.TICKETS_TABLE_COLUMN_SIZES_IN_PX.ACTIONS}>
      <Menu>
        {actions.map((action, index) => {
          if (action.type === ticketActions.SEPARATOR) {
            return <ActionComponent key={`${action.type}-${index}`} {...action} />;
          }

          if (action.type === ticketActions.NO_AVAILABLE_ACTIONS) {
            return <ActionComponent key={`${action.type}-${index}`} {...action} />;
          }

          const { enabled } = action;
          if (!enabled) {
            return (
              <Tooltip
                key={action.type}
                component={<TooltipHeader>{action.disabledTooltip}</TooltipHeader>}
                position="left"
                skin="dark"
              >
                <MenuItem {...action} key={action.type} onClick={action.onClick}>
                  <ActionComponent {...action} />
                </MenuItem>
              </Tooltip>
            );
          }
          return (
            <MenuItem {...action} key={action.type} onClick={action.onClick}>
              <ActionComponent {...action} />
            </MenuItem>
          );
        })}
      </Menu>
      <RegionContainerComponent>
        <RegionTextComponent>{currentWorkingArea}</RegionTextComponent>
        <RegionFlagComponent>{workingAreaFlag}</RegionFlagComponent>
      </RegionContainerComponent>
    </StyledColumn>
  );
};

export default ActionsColumn;
